import {
  FETCH_FAVORITES_REQUEST,
  FETCH_FAVORITES_SUCCESS,
  FETCH_FAVORITES_FAILURE,
  FETCH_DISLIKES_REQUEST,
  FETCH_DISLIKES_SUCCESS,
  FETCH_DISLIKES_FAILURE,
  SET_ACTIVE_TAB,
  CLEAR_RIGHT_SWIPES_REQUEST,
  CLEAR_RIGHT_SWIPES_SUCCESS,
  CLEAR_RIGHT_SWIPES_FAILURE,
  CLEAR_LEFT_SWIPES_REQUEST,
  CLEAR_LEFT_SWIPES_SUCCESS,
  CLEAR_LEFT_SWIPES_FAILURE
} from './favoritesActionTypes'

const initialState = {
  loading: false,
  favorites: [],
  dislikes: [],
  activeTab: 'favorites',
  error: ''
}

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAVORITES_REQUEST:
    case FETCH_DISLIKES_REQUEST:
    case CLEAR_RIGHT_SWIPES_REQUEST:
    case CLEAR_LEFT_SWIPES_REQUEST:
      return {
        ...state,
        loading: true,
        error: ''
      }
    case FETCH_FAVORITES_SUCCESS:
      return {
        ...state,
        loading: false,
        favorites: action.payload.results || action.payload,
        error: ''
      }
    case FETCH_DISLIKES_SUCCESS:
      return {
        ...state,
        loading: false,
        dislikes: action.payload.results || action.payload,
        error: ''
      }
    case CLEAR_RIGHT_SWIPES_SUCCESS:
      return {
        ...state,
        loading: false,
        favorites: [],
        error: ''
      }
    case CLEAR_LEFT_SWIPES_SUCCESS:
      return {
        ...state,
        loading: false,
        dislikes: [],
        error: ''
      }
    case FETCH_FAVORITES_FAILURE:
    case FETCH_DISLIKES_FAILURE:
    case CLEAR_RIGHT_SWIPES_FAILURE:
    case CLEAR_LEFT_SWIPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || action.payload
      }
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload
      }
    default:
      return state
  }
}

export default favoritesReducer
